/**
 * components/tableElements/EmptyState.jsx
 */

import { __ } from "@wordpress/i18n";
import { Search, Settings, Plus } from "lucide-react";
import { useCrudList } from "../../context/CrudContext";

const getAddNewUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.set("page", "wpbean-product-gallery-rule");
    url.searchParams.delete("id");
    return url.toString();
};

export default function EmptyState() {
    const { state } = useCrudList();
    const { search, status } = state;
    const isFiltered = Boolean(search || status);

    return (
        <div className="px-6 py-12 text-center">
            <div className="text-gray-400 mb-4">
                {isFiltered ? (
                    <Search className="w-12 h-12 mx-auto" />
                ) : (
                    <Settings className="w-12 h-12 mx-auto" />
                )}
            </div>

            <h3 className="text-lg font-medium text-gray-900 mb-2">
                {isFiltered
                    ? __(
                          "No gallery rules found",
                          "wpbean-product-gallery-slider-for-woocommerce",
                      )
                    : __(
                          "No gallery rules yet",
                          "wpbean-product-gallery-slider-for-woocommerce",
                      )}
            </h3>

            <p className="text-gray-500 mb-4">
                {isFiltered
                    ? __(
                          "Try adjusting your search or filter to find what you're looking for.",
                          "wpbean-product-gallery-slider-for-woocommerce",
                      )
                    : __(
                          "Get started by creating your first gallery rule.",
                          "wpbean-product-gallery-slider-for-woocommerce",
                      )}
            </p>

            {!isFiltered && (
                <a
                    href={getAddNewUrl()}
                    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors no-underline"
                >
                    <Plus className="w-4 h-4 me-2" />
                    {__(
                        "Add New",
                        "wpbean-product-gallery-slider-for-woocommerce",
                    )}
                </a>
            )}
        </div>
    );
}
